import { Box, Button, Typography } from "@mui/material";
import React, { useState } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import { baseApiURL } from "../../../Utilities/utility";
import { useSelector } from "react-redux";
import SnackbarCustom from "../../../components/Snackbar/Snackbar";
import Loading from "../../../components/Loading/Loading";
import sampleExcel from "../../../assets/MLFB-Template.xlsx";


export default function StandardMLFBBulkUpload() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState("");

  const UID = useSelector((state) => state.saveUserIdReducer);
  const userdetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData
  );
  const siteToken = useSelector((state) => state.saveTokenReducer);
  const azureToken = useSelector((state) => state.saveAzureTokenReducer);

  const [snackMessage, setSnackMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [open, setOpen] = useState(false);
  const [isLoader, setIsLoader] = useState(false);

  const handleSnackOpen = (text, type) => {
    setSnackMessage(text);
    setAlertType(type);
    setOpen(true);
  };

  const handlefilechange = (event) => {
    const file = event.target.files[0];
    if (
      file &&
      file.type ==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      setSelectedFile(file);
      setError("");
    } else {
      setError("Please select a valid .xlsx file");
      setSelectedFile(null);
    }
  };

  // snackbar close
  const handleClose = (e) => {
    setOpen(false);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      setError("Please select a file before uploading");
      return;
    }

    setIsLoader(true);
    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await fetch(baseApiURL + "/StandardMLFB/BulkUpdate", {
        method: "post",
        headers: {
          // Accept: "application/json, text/plain, */*",
          // "Content-Type": "application/json",
          Authorization: "Bearer " + siteToken.token,
          UserEmail: userdetails.userEmail,
          RoleName: userdetails.roleName,
          Gid: userdetails.gid,
          Roleid: userdetails.roleId,
          AzureToken: azureToken.token,
          userId: userdetails.userId,
        },
        body: formData,
      });
      const result = await response.json();
      if (result?.result?.response) {
        handleSnackOpen(result?.result?.responseMsg, "success");
        setIsLoader(false);
      } else {
        handleSnackOpen(result?.result?.responseMsg, "error");
        setIsLoader(false);
      }
    } catch (error) {
      console.log("Error While Uploading file :", error);
      handleSnackOpen("Error while uploading file", "error");
      setIsLoader(false);
    }
  };

  const handleCancel = () => {
    setSelectedFile(null);
    setError("");
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      justifyContent="center"
      sx={{
        border: "1px solid #ccc",
        padding: "20px",
        borderRadius: "8px",
        width: "100%",
        height: "100%",
        margin: "auto",
      }}
    >
      <h4 style={{ marginTop: "10px", fontWeight: "bold", fontSize: "18px" }}>
        Standard MLFB Bulk Update
      </h4>

      <Button
        variant="contained"
        component="label"
        sx={{ marginBottom: "16px" }}
      >
        Choose File
        <input type="file" hidden accept=".xlsx" onChange={handlefilechange} />
      </Button>

      {selectedFile && (
        <Typography sx={{ marginBottom: "16px" }}>
          Selected File : {selectedFile.name}
        </Typography>
      )}

      {error && (
        <Typography color="error" variant="body2" sx={{ marginBottom: "16px" }}>
          {error}
        </Typography>
      )}

      <Box display="flex" gap="10px">
        <Button
          variant="contanied"
          className="btn"
          onClick={handleUpload}
          disabled={!selectedFile}
        >
          Upload
        </Button>
        <Box display="flex" gap="20px">
          <Button
            className="btn"
            color="secondary"
            // startIcon={<CancelIcon />}
            onClick={handleCancel}
          >
            Cancel
          </Button>
        </Box>

        <div
          style={{
            textAlign: "right",
            padding: "10px",
            textDecoration: "underline",
          }}
        >
          <a href={sampleExcel} download="Standard-MLFB.xlsx" style={{color:'darkblue', fontWeight:'bold'}}>
          Download Sample template
          </a>
        </div>
      </Box>
      {isLoader ? <Loading loaderText="Loading...!" /> : <></>}
      <>
        <SnackbarCustom
          open={open}
          message={snackMessage}
          alertType={alertType}
          handleClose={handleClose}
        />
      </>
    </Box>
  );
}
